<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="观看数" prop="lookNum" >-->
      <!--        <a-input v-model="form.lookNum" placeholder="请输入观看数" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="繁体剧名" prop="videoName" >
        <a-input show-count v-model="form.videoName" placeholder="请输入繁体剧名" />
      </a-form-model-item>
      <a-form-model-item label="英文剧名" prop="videoNameEn" >
        <a-input show-count v-model="form.videoNameEn" placeholder="请输入英文剧名" />
      </a-form-model-item>
      <a-form-model-item label="简体剧名" prop="videoNameCn" >
        <a-input show-count v-model="form.videoNameCn" placeholder="请输入简体剧名" />
      </a-form-model-item>
      <a-form-model-item label="马来剧名" prop="videoNameBm" >
        <a-input show-count v-model="form.videoNameBm" placeholder="请输入马来剧名" />
      </a-form-model-item>
      <a-form-model-item label="印尼剧名" prop="videoNameIn" >
        <a-input show-count v-model="form.videoNameIn" placeholder="请输入印尼剧名" />
      </a-form-model-item>
      <a-form-model-item label="所属片商" prop="filmId" >
            <a-select v-model="form.filmId" allow-clear>
              <a-select-option v-for="item in filmList" :key="item.id" :value="item.id">{{ item.nickName }}</a-select-option>
            </a-select>
      </a-form-model-item>
      <a-form-model-item label="繁体封面图" prop="coverUrl" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.coverUrl"
          :showUploadList="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          :beforeUpload="beforeUpload"
          :customRequest="handleChange"
        >
          <plus-outlined />
          <img v-if="form.coverUrl" :src="form.coverUrl" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="英文封面图" prop="coverUrlEn" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.coverUrlEn"
          :showUploadList="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          :beforeUpload="beforeUpload1"
          :customRequest="handleChange1"
        >
          <plus-outlined />
          <img v-if="form.coverUrlEn" :src="form.coverUrlEn" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading1 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="简体封面图" prop="coverUrlCn" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.coverUrlCn"
          :showUploadList="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          :beforeUpload="beforeUpload2"
          :customRequest="handleChange2"
        >
          <plus-outlined />
          <img v-if="form.coverUrlCn" :src="form.coverUrlCn" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading2 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="马来封面图" prop="coverUrlBm" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.coverUrlBm"
          :showUploadList="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          :beforeUpload="beforeUpload3"
          :customRequest="handleChange3"
        >
          <plus-outlined />
          <img v-if="form.coverUrlBm" :src="form.coverUrlBm" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading3 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="印尼封面图" prop="coverUrlIn" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.coverUrlIn"
          :showUploadList="false"
          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"
          :beforeUpload="beforeUpload4"
          :customRequest="handleChange4"
        >
          <plus-outlined />
          <img v-if="form.coverUrlIn" :src="form.coverUrlIn" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading4 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="总集数" prop="totalNum" >
        <a-input-number :min="1" v-model="form.totalNum" placeholder="请输入总集数" />
      </a-form-model-item>
      <a-form-model-item label="标签" prop="type" >
        <a-select placeholder="请选择标签" v-model="form.type">
          <a-select-option :key="0">无</a-select-option>
          <a-select-option :key="1">NEW</a-select-option>
          <a-select-option :key="2">Hot</a-select-option>
          <a-select-option :key="3">首播</a-select-option>
          <a-select-option :key="4">独播</a-select-option>
          <a-select-option :key="5">FREE</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="是否上映" prop="isRelease" >
        <a-select placeholder="请选择是否上映" @change="updateIsGo" v-model="form.isRelease">
          <a-select-option :key="0">否</a-select-option>
          <a-select-option :key="1">是</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="this.isGo=='0'" label="上映时间" prop="releaseTime" >
        <a-date-picker
          :allow-clear="true"
          size="default"
          v-model="form.releaseTime"
          placeholder="上映时间"
          value-format="YYYY-MM-DD"
          format="YYYY-MM-DD">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="分类" prop="tagIds" >
        <!--        <a-input v-model="form.tagIds" placeholder="请输入标签ids" />-->
        <a-tree-select
          v-model="tagIds"
          style="width: 100%"
          :tree-data="treeData"
          tree-checkable
          search-placeholder="请选择分类"
          @change="changeSelect"
        />
      </a-form-model-item>
      <!--      <a-form-model-item label="前多少集可以使用金币观看" prop="limitNum" >-->
      <!--        <a-input-number :min="0" v-model="form.limitNum" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="前多少集可以免费观看" prop="freeLimitNum" >
        <a-input-number :min="0" v-model="form.freeLimitNum" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="每集金币价格" prop="diamondPrice" >
        <a-input-number :min="0" v-model="form.diamondPrice" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="每集金币价格(优惠价格)" prop="discountPrice" >
        <a-input-number :min="0" v-model="form.discountPrice" placeholder="请输入" />
      </a-form-model-item>
      <!--      <a-form-model-item label="每集金币价格" prop="goldPrice" >-->
      <!--        <a-input-number :min="0" v-model="form.goldPrice" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="繁体简介" prop="introductions" >
        <a-textarea show-count :maxLength="500" v-model="form.introductions" placeholder="请输入繁体简介" />
      </a-form-model-item>

      <a-form-model-item label="英文简介" prop="introductionsEn" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsEn" placeholder="请输入英文简介" />
      </a-form-model-item>
      <a-form-model-item label="简体简介" prop="introductionsCn" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsCn" placeholder="请输入简体简介" />
      </a-form-model-item>
      <a-form-model-item label="马来简介" prop="introductionsBm" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsBm" placeholder="请输入马来简介" />
      </a-form-model-item>
      <a-form-model-item label="印尼简介" prop="introductionsIn" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsIn" placeholder="请输入印尼简介" />
      </a-form-model-item>

      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/video/video'
import { listTag } from '@/api/video/tag'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'
import UploadFileToVOD from "@/api/vod.js"
import { uploadCos } from '@/api/common/index'
import request from '@/utils/request'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      filmList:[],
      submitLoading: false,
      formTitle: '',
      isGo: false,
      tagIds: [],
      // 表单参数
      form: {
        id: null,

        lookNum: null,

        limitNum: null,

        diamondPrice: null,
        discountPrice: null,
        goldPrice: null,

        introductions: null,
        introductionsEn: null,
        introductionsCn: null,
        introductionsBm: null,
        introductionsIn: null,

        tagIds: null,

        totalNum: null,
        releaseTime: null,
        videoName: null,
        videoNameEn: null,
        videoNameCn: null,
        videoNameBm: null,
        videoNameIn: null,

        coverUrl: null,
        coverUrlEn: null,
        coverUrlCn: null,
        coverUrlBm: null,
        coverUrlIn: null,

        createTime: null,
        freeLimitNum: null,
        remark: null,
        isRelease: 1
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading: false,
      uploadLoading1: false,
      uploadLoading2: false,
      uploadLoading3: false,
      uploadLoading4: false,
      treeData: [],
      rules: {
      filmId: [
          { required: true, message: '所属片商不能为空' }
        ],
        lookNum: [
          { required: true, message: '观看数不能为空' }
        ],
        limitNum: [
          { required: true, message: '前多少集可以使用金币观看不能为空' }
        ],
        freeLimitNum: [
          { required: true, message: '前多少集可以免费观看不能为空' }
        ],
        tagIds: [
          { required: true, message: '标签不能为空' }
        ],
        totalNum: [
          { required: true, message: '总集数不能为空' }
        ],
        releaseTime: [
          { required: true, message: '请选择上映时间' }
        ],
        videoName: [
          { required: true, message: '剧名不能为空' }

        ],
        videoNameEn: [
          { required: true, message: '英文剧名不能为空' }

        ],
        introductions: [
          { max: 500, message: '简介最多500字' }
        ],
        introductionsEn: [
          { max: 500, message: '简介最多500字' }
        ],
        coverUrl: [
          { required: true, message: '封面图不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.filmUserList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getAllList()
    
  },
  methods: {
    filmUserList() {
      this.filmList = []
      request.get('/system/users/filmUserList').then(res => {
        this.filmList = res.data
      })
    },
    updateIsGo(value) {
      this.isGo = value
    },
    handleChange(info) {
      const that = this
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //     console.log(fileName)
      //     that.form.coverUrl = fileName[0].url// 文件名
      //     that.uploadLoading = false
      //   }
      //
      // })

      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },
      });
      that.uploadLoading = false
    },
    handleChange1(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlEn = fileName[0]// 文件名
          that.uploadLoading1 = false
        }

      })
      that.uploadLoading1 = false
    },
    handleChange2(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlCn = fileName[0]// 文件名
          that.uploadLoading2 = false
        }

      })
      that.uploadLoading2 = false
    },
    handleChange3(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlBm = fileName[0]// 文件名
          that.uploadLoading3 = false
        }

      })
      that.uploadLoading3 = false
    },
    handleChange4(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlIn = fileName[0]// 文件名
          that.uploadLoading4 = false
        }

      })
      that.uploadLoading4 = false
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading = false
        return false
      }
      this.form.coverUrl = ''
      // TODO 驗證文件大小
    },
    beforeUpload1: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading1 = false
        return false
      }
      this.form.coverUrlEn = ''
      // TODO 驗證文件大小
    },
    beforeUpload2: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading2 = false
        return false
      }
      this.form.coverUrlCn = ''
      // TODO 驗證文件大小
    },
    beforeUpload3: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading3 = false
        return false
      }
      this.form.coverUrlBm = ''
      // TODO 驗證文件大小
    },
    beforeUpload4: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading4 = false
        return false
      }
      this.form.coverUrlIn = ''
      // TODO 驗證文件大小
    },
    handleUpload(info) { // 上传主图(一张图)
      console.log(info)
      const that = this
      this.form.coverUrl = ''
      this.uploadLoading = true
      uploadCos(info.file)
    //  , function (fileName) {
    //   console.log('--------------------------------')
    //   console.log(fileName)
    //   console.log('--------------------------------')
    //   that.uploadLoading = false;
    //   that.form.coverUrl = fileName;
    // }
    },
    changeSelect(e, label, extra) {
      this.tagIds = e
      this.form.tagIds = e.join(',')
    },
    getAllList() {
      listTag().then(res => {
        console.log(res.data)
        this.treeData = res.data.map(i => ({
          title: i.tagTitle,
          value: i.id,
          key: i.id
        }))
      })
    },
    onClose () {
      this.tagIds = null
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        lookNum: null,
        limitNum: null,
        diamondPrice: null,
        discountPrice : null,
        goldPrice: null,
        introductions: null,
        introductionsEn: null,
        tagIds: [],
        totalNum: null,
        type: 0,
        videoName: null,
        videoNameEn: null,
        coverUrl: null,
        createTime: null,
        remark: null,
        isRelease: 1,
        releaseTime: null,
        filmId: null,
        freeLimitNum: null
      }

      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.updateIsGo(0)
      this.isGo = 1
      // this.form={
      //   id: null,
      //
      //   lookNum: null,
      //
      //   limitNum: null,
      //
      //   diamondPrice: null,
      //
      //   goldPrice: null,
      //
      //   introductions: null,
      //   introductionsEn: null,
      //
      //   tagIds: null,
      //
      //   totalNum: null,
      //
      //   videoName: null,
      //   videoNameEn: null,
      //
      //   coverUrl: null,
      //
      //   createTime: null,
      //
      //   remark: null,
      //   isRelease:1
      // }
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({ 'id': id }).then(response => {
        this.form = response.data
        this.isGo = response.data.isRelease
        if (response.data.tagIds) {
          this.tagIds = response.data.tagIds.split(',')
        } else {
          this.tagIds = null
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.filmId === undefined || this.form.filmId === 'undefined') {
                this.form.filmId = null;
              }
           console.log(this.form)
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVideo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVideo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
